import { useDispatch } from 'react-redux';
import { updateAlert } from '../redux/actionCreators/alert';

/*
  Report headers called Submit with whatever the date pickers held: an empty date
  threw inside the date conversion and nothing happened, and From after To quietly
  returned an empty report. Returns a check that shows the reason instead.

    const rangeOk = useDateRangeCheck();
    onClick={() => rangeOk(fromDate, toDate) && handleSubmitAction(...)}
*/
export default function useDateRangeCheck() {
    const dispatch = useDispatch();

    return (fromDate, toDate) => {
        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (!from || isNaN(from) || !to || isNaN(to)) {
            dispatch(updateAlert('Select both From and To dates', 'error'));
            return false;
        }
        if (from.setHours(0, 0, 0, 0) > to.setHours(0, 0, 0, 0)) {
            dispatch(updateAlert('From date must be on or before To date', 'error'));
            return false;
        }
        return true;
    };
}
